export default function CaretDown() {
  return (
    <svg width={9.6} height={4.8} viewBox="0 0 2 1">
      <path d="M0,0 L2,0 L1,1 Z" stroke="none" />
    </svg>
  );
}
